// const backEndTools
const backEndTools = [
  {
    value: "Java",
    label: "Java"
  },
  {
    value: "Go",
    label: "Go"
  },
  {
    value: "C#",
    label: "C#"
  },
  {
    value: "PHP",
    label: "PHP"
  },
  {
    value: "NodeJs",
    label: "NodeJs"
  },
  {
    value: "TypeScript",
    label: "TypeScript"
  },
  {
    value: "C++",
    label: "C++"
  },
  {
    value: "C",
    label: "C"
  },
  {
    value: "Ruby",
    label: "Ruby"
  },
  {
    value: "Swift",
    label: "Swift"
  },
  {
    value: "Kotlin",
    label: "Kotlin"
  },
  {
    value: "R",
    label: "R"
  },
  {
    value: "WebAssembly",
    label: "WebAssembly"
  },
  {
    value: "VBA",
    label: "VBA"
  },
  {
    value: "Objective-C",
    label: "Objective-C"
  },
  {
    value: "Assembly",
    label: "Assembly"
  },
  {
    value: "Scala",
    label: "Scala"
  },
  {
    value: "Rust",
    label: "Rust"
  },
  {
    value: "Dart",
    label: "Dart"
  },
  {
    value: "Elixir",
    label: "Elixir"
  },
  {
    value: "Clojure",
    label: "Clojure"
  },
  {
    value: "Python",
    label: "Python"
  },
  {
    value: "SQL",
    label: "SQL"
  },
  {
    value: "ASP.NET",
    label: "ASP.NET"
  },
  {
    value: "Express",
    label: "Express"
  },
  {
    value: "Spring",
    label: "Spring"
  },
  {
    value: "Vue.js",
    label: "Vue.js"
  },
  {
    value: "Django",
    label: "Django"
  },
  {
    value: "Flask",
    label: "Flask"
  },
  {
    value: "Laravel",
    label: "Laravel"
  },
  {
    value: "Ruby on Rails",
    label: "Ruby on Rails"
  },
  {
    value: "Drupal",
    label: "Drupal"
  },
  {
    value: "Python",
    label: "Python"
  }
];

//design tools
const designTools = [
  {
    value: "Adobe",
    label: "Adobe"
  },
  {
    value: "CSS",
    label: "CSS"
  }
];

//frontend tools
const frontEndTools = [
  {
    value: "HTML/CSS",
    label: "HTML/CSS"
  },
  {
    value: "JavaScript",
    label: "JavaScript"
  },
  {
    value: "TypeScript",
    label: "TypeScript"
  },
  {
    value: "React.js",
    label: "React.js"
  },
  {
    value: "Angular/Angular.js",
    label: "Angular/Angular.js"
  },
  {
    value: "jQuery",
    label: "jQuery"
  }
];

export { backEndTools, designTools, frontEndTools };
